export const SET_CURR_FEES = 'SET_CURR_FEES';
export const SET_OLD_FEES = 'SET_OLD_FEES';
